export default __webpack_public_path__ + "static/media/republish.44428eb6.svg";